import React from "react"
import ReactDOM from "react-dom"

import "./index.scss"

import registerServiceWorker from "./registerServiceWorker"
import DataStore, { StoreContext } from "./DataStore"

async function run() {
    //
    // DataStore
    //
    const store = new DataStore()
    store.reload()

    //
    // Run the actual app
    //

    const PublicApp = require("./PublicApp").default
    ReactDOM.render(
        <React.StrictMode>
            <StoreContext.Provider value={store}>
                <PublicApp backend={store} />
            </StoreContext.Provider>
        </React.StrictMode>,
        document.getElementById("root"),
    )
}

run().catch(e => console.error(e))

registerServiceWorker()
